// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 22H2V13H11V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13V13H22V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 11H2V2H11V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.4551 4.54395L22.6797 6L19.4551 7.45508L18 10.6797L16.5439 7.45508L13.3203 6L16.5439 4.54395L18 1.32031L19.4551 4.54395Z"}}]};

const AiToolFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-tool-filled',
    ref,
    icon: element,
  },
));

AiToolFilledIcon.displayName = 'AiToolFilledIcon';

export default AiToolFilledIcon;
